'use client'

import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import type { JoinedGroup } from '@/types/group'
import cardStyles from '@/components/Shared/Card/styles.module.scss'
import styles from './styles.module.scss'

interface CompanyGroupCardProps {
  group: JoinedGroup
  used?: string
}

export default function CompanyGroupCard({ group, used = '' }: CompanyGroupCardProps) {
  const groupLink = `/${group.company.openUrl}/group/${group.id}`

  return (
    <article
      className={clsx(cardStyles.cardBase, styles.card, {
        [styles.carousel]: used === 'carousel',
        [styles[used]]: used && styles[used],
      })}
    >
      <Link className={cardStyles.cardLink} href={groupLink} />
      <div className={styles.cardContentsContainer}>
        <div className={styles.cardContents}>
          <div className={styles.companyLogoArea}>
            <img
              src={group.company.imageUrl || '/images/svg/dummy_logo.svg'}
              width={40}
              height={40}
              className={styles.companyLogo}
              alt={group.company.name}
              loading='lazy'
            />
          </div>
          <div className={styles.companyTitleArea}>
            <div className={styles.companyName}>{group.company.name}</div>
            <div className={styles.groupTitle}>{group.name}</div>
            <p className={styles.description}>{group.description}</p>
          </div>
        </div>
      </div>
    </article>
  )
}
